export default "__VITE_ASSET__BzVjcQUC__"